// extracted by mini-css-extract-plugin
export default {"CongratulationsModalOverlay":"CongratulationsModal_CongratulationsModalOverlay__RMV5K","CongratulationsModal":"CongratulationsModal_CongratulationsModal__XW2gH"};